import Glide from '@glidejs/glide';
import Swiper, { Pagination, EffectFade } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  Swiper.use([Pagination, EffectFade]);

  const nav = document.querySelector('.masthead--nav');

  document.querySelectorAll('.mobile-menu-toggle').forEach((el) => {
    const { expandText, collapseText } = el.dataset;

    el.addEventListener('click', () => {
      nav.classList.toggle('toggled');
      el.classList.toggle('toggled');

      el.querySelector('span').textContent = nav.classList.contains('toggled') ? collapseText : expandText;
    });
  });

  document.querySelectorAll('.parent-category > a').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();

      el.nextElementSibling.classList.add('toggled');
      document.querySelector('.mobile-category-back').classList.add('toggled');
    });
  });

  document.querySelector('.mobile-category-back').addEventListener('click', () => {
    document.querySelectorAll('.sub-menu').forEach((el) => {
      el.classList.remove('toggled');
    });
  });

  // pages
  if (document.body.classList.contains('home')) {
    document.querySelectorAll('.home-hero .glide').forEach((el) => {
      new Glide(el, {
        type: 'carousel',
        perView: 1,
      }).mount();
    });

    document.querySelectorAll('.home-products .glide').forEach((el) => {
      new Glide(el, {
        type: 'carousel',
        perView: 4,
        gap: 64,
        breakpoints: {
          768: {
            perView: 1,
          },
          992: {
            perView: 2,
          },
          1200: {
            perView: 3,
          },
        },
      }).mount();
    });
  } else if (document.body.classList.contains('woocommerce-cart')) {
    document.querySelector('.woocommerce-cart').addEventListener('click', (event) => {
      const submitButton = document.querySelector('.woocommerce-cart-form [name=update_cart]');

      if (event.target.classList.contains('cart-qty-minus')) {
        const minusButton = event.target;
        const qtyInput = minusButton.parentNode.querySelector('input[type=number]');

        const currentQty = parseInt(qtyInput.value);

        if (currentQty > 1) {
          qtyInput.value = currentQty - 1;

          console.log('odejmuje');

          jQuery(document.body).trigger('wc_fragment_refresh');
          qtyInput.dispatchEvent(
            new Event('change', {
              bubbles: true,
            })
          );

          submitButton.click();
        }
      } else if (event.target.classList.contains('cart-qty-plus')) {
        const plusButton = event.target;

        const qtyInput = plusButton.parentNode.querySelector('input[type=number]');
        const maxQuantity = qtyInput.getAttribute('max') | 99;

        const currentQty = parseInt(qtyInput.value);

        if (currentQty < maxQuantity) {
          qtyInput.value = currentQty + 1;

          jQuery(document.body).trigger('wc_fragment_refresh');
          qtyInput.dispatchEvent(
            new Event('change', {
              bubbles: true,
            })
          );

          submitButton.click();
        }
      }
    });

    document.querySelector('.woocommerce-cart').addEventListener('click', (event) => {
      if (event.target.classList.contains('cart_totals-delivery--item')) {
        document.querySelectorAll('.cart_totals-delivery--item').forEach((el) => {
          el.classList.remove('active');
        });

        event.target.classList.add('active');

        const rateId = event.target.dataset.id;

        document.querySelector(`#shipping_method [value="${rateId}"]`).click();
      }
    });
  } else if (document.body.classList.contains('single-product')) {
    // quantity buttons
    const qtyInput = document.querySelector('.qty');

    document.querySelector('.btn-quantity-minus').addEventListener('click', () => {
      const current = parseInt(qtyInput.value);
      const min = parseInt(qtyInput.getAttribute('min'));

      if (current > min) {
        qtyInput.value = current - 1;
      }
    });

    document.querySelector('.btn-quantity-plus').addEventListener('click', () => {
      let current = parseInt(qtyInput.value);
      let max = parseInt(qtyInput.getAttribute('max')) || Infinity;

      if (current < max) {
        qtyInput.value = current + 1;
      }
    });

    document.querySelectorAll('.related .related-products-wrapper').forEach((el) => {
      new Swiper(el, {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 1.5,
        centeredSlides: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 60,
          },
          992: {
            slidesPerView: 3.5,
            spaceBetween: 40,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 80,
          },
        },
      });
    });
  }
});
